import { ChartSize } from '../reports/types.ts';

export function getMediaqueryScreen(): ChartSize | null {
  if (!document.getElementById('mediaquery')) {
    console.warn(
      'No element with id "mediaquery" found. Ensure that the HTML contains an element with this id for media query detection.'
    );
    return null;
  }

  const content = window.getComputedStyle(document.getElementById('mediaquery'), ':after').getPropertyValue('content');

  return content.replace(/"/g, '') as ChartSize;
}
